import { render, staticRenderFns } from "./SchemesCategoriesDetail.vue?vue&type=template&id=c27c95e8&scoped=true"
import script from "./SchemesCategoriesDetail.vue?vue&type=script&lang=ts"
export * from "./SchemesCategoriesDetail.vue?vue&type=script&lang=ts"
import style0 from "./SchemesCategoriesDetail.vue?vue&type=style&index=0&id=c27c95e8&lang=scss"
import style1 from "./SchemesCategoriesDetail.vue?vue&type=style&index=1&id=c27c95e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27c95e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c27c95e8')) {
      api.createRecord('c27c95e8', component.options)
    } else {
      api.reload('c27c95e8', component.options)
    }
    module.hot.accept("./SchemesCategoriesDetail.vue?vue&type=template&id=c27c95e8&scoped=true", function () {
      api.rerender('c27c95e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schemes-categories/components/SchemesCategoriesDetail.vue"
export default component.exports